import React from 'react';
import { Badge } from '@exxonmobil/react-unity';
import { NODATA } from '../constant';
import { getStatusColor } from '../utils/getColor';

export const StatusBadge = ({ status }: { status: string | null }) => {
  return (
    <Badge
      style={{
        background: getStatusColor(status)
      }}
    >
      {status || NODATA}
    </Badge>
  );
};
